import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { selectPlan, selectShowCheckout, setDefaultPlanId} from './plansSlice';
import { BestLabel, CheckIcon, Description, Forbes, InvertedLogo, Label, LogoWrapper, Mashable, PlansWrapper, PressLogos, Rate, ReviewBody, ReviewHead, ReviewItem, ReviewText, ReviewerName, ReviewerPhoto, SecondaryTitle, StyledItem, StyledLi, StyledList, StyledPeriod, StyledPlanList, StyledPrice, TechCrunch, UserIcon, WhiteCheckIcon, Wrapper, StyledDisclaimer } from './styled';
import UIButton from '../../UI/UIButton';
import Timer from '../../UI/Timer';
import { PLANS } from '../../analytics/eCommerce';

const site = 'https://www.familo.net/';

const DefaultPlans = ({ onContinueClick, handleSetPlan }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const plan = useSelector(selectPlan);
    const showCheckout = useSelector(selectShowCheckout);
    const defaultPaywall = useMemo(() => {
        return [
            {
                id: 'fm-monthly-39.99',
                title: t('1_month'),
                price: '$9.99',
                week: `${t('per_week')}`,
                popular: true,
            },
            {
                id: 'fm-3month-59.99',
                title: t('3_months'),
                price: '$4.99',
                week: t('per_week'),
            },
            {
                id: 'fm-6month-71.76',
                title: t('6_months'),
                price: '$2.99',
                week: t('per_week'),
            },
        ]
    }, [t]);

    useEffect(
			() => {
				if (!showCheckout) {
					handleSetPlan(defaultPaywall[0]?.id);
					dispatch(setDefaultPlanId(defaultPaywall[0]?.id));
				}
			},
			// eslint-disable-next-line react-hooks/exhaustive-deps
			[dispatch, showCheckout]
		);

    const FEATURES = useMemo(() => {
        return [
          t("know_when_family_come_or_go"),
          t("realtime_location_sharing"),
          t("find_loved_ones"),
          t("be_notified_in_case"),
          t("get_notified_when_the_land"),
        ];
      }, [t]);
    const REVIEWS = useMemo(() => {
        return [
          {
            market: "IOS",
            reviewer: "Kevin Peters",
            reviewerSource: '../assets/reviewer1.png',
            text: t("review_1"),
          },
          {
            market: "Play",
            reviewer: "John Lee",
            reviewerSource: '../assets/reviewer2.png',
            text: t("review_2"),
          },
          {
            market: "Play",
            reviewer: "Megan Smith",
            reviewerSource: '../assets/reviewer3.png',
            text: t("review_3"),
          },
        ];
    }, [t]);
    const planDetails = useMemo(() => {
        return PLANS[plan] || {};
    }, [plan]);
    const onLinkClick = (type) => {
        if (!(type && type.length > 0)) return;
        const links = {
            terms: 'https://familo.net/en/assets/Terms_and_Conditions_Familonet_info.pdf',
            privacy: 'https://terms.familo.net/privacy-info',
            refund: 'https://familo.net/en/assets/Terms_and_Conditions_Familonet_info.pdf',
            site,
        };

        if (links[type]) window.open(links[type]);
    };

      const renderReview = (r, i) => {
        return (
          <ReviewItem key={i}>
            <ReviewHead>
              <UserIcon imgUserPath={'../assets/app-icon.svg'}/>
              <Label>{r.market}</Label>
              <Rate imgStarPath={'../assets/stars.png'}/>
            </ReviewHead>
            <ReviewBody>
              <ReviewerPhoto src={r.reviewerSource} alt={r.reviewer} />
              <ReviewerName>{r.reviewer}</ReviewerName>
            </ReviewBody>
            <ReviewText>{r.text}</ReviewText>
          </ReviewItem>
        );
      };
      const renderItem = (i, index) => {
        return (
          <StyledItem key={index}>
            {CheckIcon}
            {i}
          </StyledItem>
        );
      };
      const renderOffer = (planInfo, index) => {
        const { id, title, period, price, week, popular } = planInfo;
        const isActive = plan === id;
        return (
          <StyledLi
            active={isActive}
            onClick={() => handleSetPlan(id)}
            id={"plan-button-" + (index + 1)}
            key={id}
          >
            <StyledPeriod active={isActive}>
              <div>
                {WhiteCheckIcon}
              </div>
              <span>
                {title} {period}
              </span>
            </StyledPeriod>
            <StyledPrice>
              <span>{price}</span>
              <span>{week}</span>
            </StyledPrice>
            {popular && <BestLabel>{t("most_popular")}</BestLabel>}
          </StyledLi>
        );
      };
      const continueButton = (displayStickyBtn, sticky, id) => (
        <>
            <UIButton
              onClick={onContinueClick}
              bottomPosition={"16px"}
              displayStickyBtn={displayStickyBtn}
              position={sticky}
              displayStubBtn={false}
              customBeforeHeight={false}
              customId={`paywall-continue-button-${id}`}
            >
              {t("continue")}
            </UIButton>
            <StyledDisclaimer
                dangerouslySetInnerHTML={{ __html: t('legal_disclaimer', {
                    price: `$${planDetails?.price}`,
                    duration: t(planDetails?.disclaimer),
                    site,
                })}}
                onClick={(e) => onLinkClick(e.target.id)}
            />
        </>
      );
      return (
        <Wrapper>
          <PlansWrapper>
            <LogoWrapper>
              {InvertedLogo }
            </LogoWrapper>
            <Description>{t("best_program")}</Description>
            <Timer />
            <StyledPlanList>{defaultPaywall.map(renderOffer)}</StyledPlanList>
            <SecondaryTitle>{t("what_you_get")}</SecondaryTitle>
            <StyledList>{FEATURES.map(renderItem)}</StyledList>
          </PlansWrapper>
          {continueButton(true, "sticky", 1)}
          <PlansWrapper>
            <SecondaryTitle>{t("as_seen_on")}</SecondaryTitle>
            <PressLogos>
              {Forbes}
              {TechCrunch}
              {Mashable}
            </PressLogos>
            <SecondaryTitle>{t("customer_reviews")}</SecondaryTitle>
            {REVIEWS.map(renderReview)}
          </PlansWrapper>
          {continueButton(false, 'fixed', 2)}
        </Wrapper>
      );
};

export default DefaultPlans
